import * as React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import { showRequestACar } from '../../../../actions/modalActions';
import { getNextStep, getOverview } from '../../../../actions/claimHistoryActionsV2'

class ClaimCarHire extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            carHire: "active"
        };
        this.handleClick = this.handleClick.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
        this.getFormatDate = this.getFormatDate.bind(this);
    }

    async handleClick() {
        this.props.handleGetNextStep();
    }

    async handleToggle() {
        this.setState({ carHire: "active" });
    }

    async handleBackClick() {
        this.props.handleClaimsBackClick();
    }

    getFormatDate(date: string) {
        if (date) {
            const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
            var stringDate = date.split('T')[0];
            var formatedDate = new Date(stringDate);
            var fullFormatedDate = formatedDate.getDate().toString() + " " + monthNames[formatedDate.getMonth()] + " " + formatedDate.getFullYear().toString();
            return fullFormatedDate;
        } else {
            return "Not Found";
        }
    }

    render() {
        let currCarHireStep = this.props.claimSubmit.selectedClaimProgressStep?.claimCarHireStep.carHireSteps.filter(x => x.indCurrentStep === 1)[0]
        return (
            <>
                { currCarHireStep &&
                    <>
                        <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                        <div id="ClaimCarHire">
                            {currCarHireStep.carHireStatus?.toLowerCase() === "unconfirmed" && this.props.claimSubmit.selectedClaimProgressStep.claimType?.toLowerCase() !== 'motor vehicle repair non-driveable' && <Card className="content-box-padding-20px-with-box-shadow">
                                <Card.Body className="nopa">
                                    <p className="claim-title">Car hire</p>
                                    <p className="car-hire-description">You have car hire on your policy… Lucky you!</p>
                                    <p className="car-hire-description">That means we’ll arrange a set of wheels you can use until your claim is finalised (max 30 days).</p>
                                    <p className="car-hire-description">All you need to do once your car's booked in, is to tap the 'Request a car' button to get the ball rolling.</p>
                                    <div className="button-padding">
                                        <button className="btn btn-solid-red" onClick={this.props.handleRequestACar}>Request a car</button>
                                    </div>
                                </Card.Body>
                                <Card.Footer className="nopa">
                                    <p className="font-size-12px please-note"><b>Please note:</b> You’re responsible for the fuel, security deposit, running costs, collection, and delivery fees. The car rental company will discuss these costs with you when they call you. </p>
                                </Card.Footer>
                            </Card>}

                            {(currCarHireStep.carHireStatus?.toLowerCase() === null || currCarHireStep.carHireStatus?.toLowerCase() === "unconfirmed") && this.props.claimSubmit.selectedClaimProgressStep?.claimType?.toLowerCase() === "motor vehicle repair non-driveable" && <Card className="content-box-padding-20px-with-box-shadow" id="carHireActivateAutoMagic">
                                <Card.Body className="nopa">
                                    <p className="claim-title">Car hire</p>
                                    <p className="car-hire-description">You have car hire on your policy… Lucky you!</p>
                                    <p className="car-hire-description">This means you’ll have a car to use (for 30 days, max) until your claim’s finalised. As soon as the ‘booked in’ date of your car has been set, <b>Auto Magic</b> will arrange a set of wheels for you on behalf of King Price.</p>

                                </Card.Body>
                                <Card.Footer className="nopa">
                                    <p className="font-size-12px please-note"><b>Please note:</b> You’re responsible for the fuel, security deposit, running costs, collection, and delivery fees. The car rental company will discuss these costs with you when they call you. </p>
                                </Card.Footer>
                            </Card>}
                            {currCarHireStep.cancelStatus?.toLowerCase() === "declined" && <Card className="content-box-padding-20px-with-box-shadow" id="carHireDeclined">
                                <Card.Body className="nopa">
                                    <p className="claim-title">Car hire</p>
                                    <p className="car-hire-description">Thanks for letting us know that you don’t need car hire right now.</p>
                                    <p className="car-hire-description">If you change your mind, please tap below:</p>
                                    <div className="button-padding nopa">
                                        <button className="btn btn-solid-red" onClick={this.props.handleRequestACar}>Request a car</button>
                                    </div>
                                </Card.Body>
                            </Card>}
                            {(currCarHireStep.cancelStatus?.toLowerCase() === "cancelled" || currCarHireStep.cancelStatus?.toLowerCase() === "repudiated") && <Card className="content-box-padding-20px-with-box-shadow" id="carHireCancelled">
                                <Card.Body className="nopa">
                                    <p className="claim-title">Car hire cancelled</p>
                                    <p className="car-hire-description">Your car hire has been cancelled and you’ll need to return your rental wheels.
                                <br className="d-none d-lg-block" /> We’ll contact you soon to make arrangements.</p>
                                </Card.Body>
                            </Card>}

                        {((currCarHireStep.carHireStatus?.toLowerCase() === "confirmed" || currCarHireStep.carHireStatus?.toLowerCase() === "acknowledged" || currCarHireStep.carHireStatus?.toLowerCase() === "on rent" || currCarHireStep.carHireStatus?.toLowerCase() === "terminated" || currCarHireStep.carHireStatus?.toLowerCase() === "invoiced") && currCarHireStep.cancelStatus === null && this.props.claimSubmit.selectedClaimProgressStep?.claimType?.toLowerCase() !== "motor vehicle repair non-driveable") && <Card className="content-box-padding-20px-with-box-shadow" id="carHireRental">
                                <Card.Body className="nopa">
                                    <p className="claim-title">Car hire</p>
                                    <p className="car-hire-description">You have car hire on your policy… Lucky you!</p>
                                    <p className="car-hire-description">We’ve arranged a car for you to use (for 30 days, max) until your claim’s finalised.</p>
                                    <p className="font-size-12px"><b>Please note:</b> You’re responsible for the fuel, security deposit, running costs, collection, and delivery fees.</p>
                                    <hr />
                                    <div>
                                        <p className="In-progress-rental"><img alt="" title="" src="Images/Claims/status.png" className="progressStatus" />{((currCarHireStep.carHireStatus?.toLowerCase() === "terminated" || currCarHireStep.carHireStatus?.toLowerCase() === "invoiced") && currCarHireStep.cancelStatus === null) ? ("Return rental wheels") : "Rental wheels arranged"}</p>
                                        {((currCarHireStep.carHireStatus?.toLowerCase() === "terminated" || currCarHireStep.carHireStatus?.toLowerCase() === "invoiced") && currCarHireStep.cancelStatus === null) && <p className="car-hire-description">Your claim has been completed so you’ll need to return your rental wheels. We’ll contact you soon to make arrangements.</p>}
                                    </div>
                                    <hr />
                                    {currCarHireStep.carGroup &&
                                        <>
                                            <div className="row noma">
                                                <div className="col-12 col-lg-6 nopa">
                                                    <p className="Claim-logged-rental">Your rental car tier</p>
                                                </div>
                                                <div className="col-12 col-lg-6 nopa">
                                                    <p className="pull-lg-right">{currCarHireStep.carGroup}</p>
                                                </div>
                                            </div>


                                            <hr className="noma-top" />
                                        </>
                                    }
                                    {currCarHireStep?.pickUpDate &&
                                        <>
                                            <div className="row noma">
                                                <div className="col-12 col-lg-6 nopa">
                                                    <p className="Claim-logged-rental">Rental start date</p>
                                                </div>
                                                <div className="col-12 col-lg-6 nopa">
                                                    <p className="pull-lg-right rental-date">{this.getFormatDate(currCarHireStep.pickUpDate)}</p>
                                                </div>
                                            </div>
                                            <hr className="noma-top" />
                                        </>
                                    }
                                    {currCarHireStep?.dropOffDate &&

                                        <div className="row noma">
                                            <div className="col-12 col-lg-6 nopa">
                                                <p className="Claim-logged-rental">Rental end date</p>
                                            </div>
                                            <div className="col-12 col-lg-6 nopa">
                                                <p className="pull-lg-right rental-date">{this.getFormatDate(currCarHireStep.dropOffDate)}</p>
                                            </div>
                                        </div>
                                    }
                                </Card.Body>
                            </Card>}
                        </div>
                    </>
                }
                {!currCarHireStep &&
                    <>
                        <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                        <div id="ClaimCarHire">
                            <Card className="content-box-padding-20px-with-box-shadow">
                                <Card.Body className="nopa">
                                    <p className="claim-title">Car hire</p>
                                    <p className="car-hire-description">You have car hire on your policy… Lucky you!</p>
                                    <p className="car-hire-description">That means we’ll arrange a set of wheels you can use until your claim is finalised (max 30 days).</p>
                                    <p className="car-hire-description">All you need to do once your car's booked in, is to tap the 'Request a car' button to get the ball rolling.</p>
                                    <div className="button-padding">
                                        <button className="btn btn-solid-red" onClick={this.props.handleRequestACar}>Request a car</button>
                                    </div>
                                </Card.Body>
                                <Card.Footer className="nopa">
                                    <p className="font-size-12px please-note"><b>Please note:</b> You’re responsible for the fuel, security deposit, running costs, collection, and delivery fees. The car rental company will discuss these costs with you when they call you. </p>
                                </Card.Footer>
                            </Card>
                        </div>
                    </>
                }
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),
        handleRequestACar: () => dispatch(showRequestACar()),
        handleClaimsBackClick: () => dispatch(getOverview()),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimCarHire);
